import React from 'react';
import GlobalNav from '../components/GlobalNav';
import Footer from '../components/Footer';
import './SoulSessions.css';

const HOUSE_RULES = [
  "Sign-Up: In-advance via this form or 6:00pm on-site.",
  "Time Limits: 10 Minutes per artist.",
  "Respect: Help us cultivate a supportive and attentive atmosphere.",
  "Sound: Mics, PA, monitors provided. You may bring your own (acoustic) instrument",
  "Food/Drinks: No outside food or drinks.",
  "Recording/Streaming: NO RECORDING WITHOUT ARTIST PERMISSION. We may document some segments for social media/web.",
  "House Rules: This is an all-ages event. Please use appropriate language and observe behavior policies.",
  "Diversity/Inclusion: All backgrounds/styles (Music, Poetry, Comedy etc.).",
  "Promotion: Help spread the word! Tag @MusicIsHealingUs & @JAPATTY on IG).",
  "Feedback: We value your opinion. Share your input and let us know what worked (or didn't).",
];

export default function SoulSessions() {
  return (
    <div className="soul-page">
      <GlobalNav activeHref="/programs" />

      {/* Hero */}
      <section
        className="soul-hero"
        style={{ backgroundImage: "url('/images/word-sound-kwe.jpg')" }}
      >
        <div className="soul-hero-inner">
          <img className="soul-logo" src="/images/soulsessions-logo.png" alt="Soul Sessions" />
          <p className="soul-hero-tagline">An Acoustic Dub Poetry Night</p>
          <div className="soul-hero-ctas">
            <a
              className="soul-btn-primary"
              href="https://www.eventbrite.com/e/soul-sessions-tickets-1988586644184?aff=oddtdtcreator"
              target="_blank" rel="noopener noreferrer"
            >
              Get tickets now
            </a>
            <a className="soul-btn-secondary" href="#house-code">
              Sign up to perform
            </a>
          </div>
        </div>
      </section>

      {/* Logistics + flyer */}
      <section className="soul-logistics">
        <div className="soul-logistics-inner">
          <div className="soul-logistics-left">
            <div className="soul-logistics-cards">
              <div className="soul-logistics-card">
                <div className="soul-logistics-icon">🕐</div>
                <div className="soul-logistics-label">When</div>
                <p>Every First Saturday<br />6:00 PM – 9:00 PM</p>
              </div>
              <div className="soul-logistics-card">
                <div className="soul-logistics-icon">📍</div>
                <div className="soul-logistics-label">Where</div>
                <p>JA PATTY<br />1577 Westminster St, Providence, RI</p>
              </div>
            </div>

            <div className="soul-divider" />

            <p className="soul-body-text">
              Join us for an evening of live music, dub poetry and ital eats!
              <br /><br />
              Music Is Healing presents "Soul Sessions", an intimate party for
              artists of any style to come together and share works in progress
              in a creative and supportive community.
              <br /><br />
              <em><strong>Schedule of events:</strong></em><br />
              • 6:00pm – Doors Open | Sign-Up | Early Vibes<br />
              • 7:30pm – Featured Artist Performance<br />
              • 8:30pm – Soul Session Jam / Open Mic
            </p>
          </div>

          <div className="soul-logistics-right">
            <img src="/images/events/soulsessions-flyer.png" alt="Soul Sessions Flyer" />
          </div>
        </div>
      </section>

      {/* House code */}
      <section className="soul-house-code" id="house-code">
        <div className="soul-house-code-inner">
          <h2 className="soul-house-title">House Code</h2>
          <p className="soul-house-intro">
            Soul Sessions is more than an open mic; it is a community sanctuary
            that serves as an invaluable platform for musicians, vocalists, and
            artists of various genres to cultivate essential experience.
            Performing before an audience, regardless of its size, facilitates
            the development of stage presence and the conquering of stage
            jitters. These elements are pivotal for those who aspire to achieve
            success in their artistic endeavors. We look forward to your
            presence and participation! See you there!
          </p>

          <div className="soul-rules-panel">
            <ol className="soul-rules-list">
              {HOUSE_RULES.map((rule, i) => (
                <li key={i} className="soul-rule-row">
                  <span className="soul-rule-icon">♪</span>
                  <span>{rule}</span>
                </li>
              ))}
            </ol>
          </div>

          <p className="soul-signoff">
            Thank you for being a part of Music Is Healing's Soul Sessions
            night. We hope you have a fantastic time, whether you're performing
            or cheering on our tribe of talented artists. Let's make it a night
            to remember! —kwe
          </p>
        </div>
      </section>

      {/* Mailing list */}
      {/* <section className="soul-mailing">
        <h3 className="soul-mailing-title">Ready to join the mailing list?</h3>
        <form method="post" action="/listserv" className="soul-mailing-form">
          <input type="text" name="name" placeholder="Name" required className="soul-input" />
          <input type="email" name="email" placeholder="Email" required className="soul-input" />
          <button type="submit" className="soul-btn-primary">Subscribe</button>
        </form>
      </section> */}

      <Footer />
    </div>
  );
}
